import { Navigate } from 'react-router-dom'

/** Legacy route — redirects to unified Listings management (EPG section). */
export default function ListingsSyncPage() {
  return <Navigate to="/admin/listings-management#epg" replace />
}
